import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

export interface INoResults {
  text?: string;
  query?: string;
}

const NoResults: FunctionComponent<INoResults> = ({ text }) =>
  text ? (
    <div
      className="search-results__no-results"
      dangerouslySetInnerHTML={{ __html: text }}
    >
      {text}
    </div>
  ) : null;

export default NoResults;
